import next from './Next';

export default function (step, Q) {
    return function (eventName) {
        if (step[eventName]) {
            return step[eventName];
        }
        step[eventName] = next(step, Q);
        return step[eventName];
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/flow/build/Event.js
// module id = 757
// module chunks = 0